import React from "react";

function About() {
    return(
        <div>
            <h1>ABOUT</h1>
        </div>
    )
}

export default About;